import React from "react";
import BondBasicInformationBase from "../../shared/components/BondBasicInformationBase";
import { BOND_BASIC_INFO_CONFIG } from "../../shared/bondBasicInformationConfig";
import { BOND_STEP_DATA_UPDATE_ERRORS } from "../../shared/bondWizardStepPropTypes";

const BasicInformation = (props) => (
  <BondBasicInformationBase config={BOND_BASIC_INFO_CONFIG.va} {...props} />
);

BasicInformation.propTypes = BOND_STEP_DATA_UPDATE_ERRORS;

export default BasicInformation;
